var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-item-box"},[_c('img',{attrs:{"src":_vm.headerPhoto
        ? _vm.$global.imgUrl + _vm.headerPhoto
        : require('@/assets/img/mobile-img/jigou-logo.png'),"alt":""}}),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }